"use client"

import PROFILE_ICON_DART from "@assets/svg/profile_icon_dart.svg"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@heroui/react"
import { signout } from "@lib/data/customer"
import { ArrowRightOnRectangle } from "@medusajs/icons"
import type { StoreCustomer } from "@medusajs/types"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import Image from "next/image"
import { useParams } from "next/navigation"
import { useEffect, useRef, useState } from "react"

type Props = {
  customer: StoreCustomer | null
  onClose: () => void
  isMobile?: boolean
}

function AccountButton({ customer, onClose, isMobile = false }: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const { countryCode } = useParams() as { countryCode: string }

  const handleToggleDropdown = (event: React.MouseEvent) => {
    event.stopPropagation()
    setIsOpen((prev) => !prev)
  }

  const handleLogout = async () => {
    onClose()
    await signout(countryCode)
    setIsOpen(false)
  }

  useEffect(() => {
    if (!isOpen) return

    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [isOpen])

  return (
    <div className="relative flex items-center gap-2 text-sm">
      {customer ? (
        <Dropdown>
          <DropdownTrigger>
            <div
              data-testid="welcome-message"
              data-value={customer?.first_name}
              onClick={handleToggleDropdown}
              className="cursor-pointer text-[14px] flex items-center gap-2"
            >
              <div>Xin chào, {customer?.first_name}</div>
              {isMobile && <ArrowRightOnRectangle />}
            </div>
          </DropdownTrigger>
          <DropdownMenu aria-label="Dropdown menu with icons" variant="faded">
            <DropdownItem
              startContent={<ArrowRightOnRectangle />}
              onClick={handleLogout}
              key={"logout"}
            >
              <span>Đăng xuất</span>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      ) : (
        <div className="flex items-center gap-2" onClick={() => onClose()}>
          <Image src={PROFILE_ICON_DART} alt="profile_icon" />
          <LocalizedClientLink href="/account" data-testid="nav-account-link">
            Đăng ký/
            <br />
            Đăng nhập
          </LocalizedClientLink>
        </div>
      )}
    </div>
  )
}

export default AccountButton
